// extracted by mini-css-extract-plugin
export var cardContainer = "_pv-0";
export var cardHeader = "_pv-2";
export var collapsedState = "_pv-3";
export var dragHandle = "_pv-5";
export var dragHandleIcon = "_pv-6";
export var dragging = "_pv-1";
export var titleArea = "_pv-4";